var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oauth-auth-redirect my-5"},[_c('div',{staticClass:"container"},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('b-spinner')],1):_c('div',{staticClass:"text-center"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }